import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  NoticeContainer,
  NoticeContent,
  FlexBox,
  ButtonWrapper,
  TextWrapper,
  NoticeText,
  SecondaryButtonWrapper,
  NoticeBlock,
  NoticeHeading,
  NoticeFooter
} from "./styles";
import downArrow from "../../../assets/icons/short-arrow-b.svg";
import upArrow from "../../../assets/icons/short-arrow-t.svg";
class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  componentDidMount() {
    if (this.props.tiff) {
      this.setState({ show: true });
    }
  }
  toggleNoticeBlock = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    return (
      <div>
        <NoticeContainer
          message={
            <NoticeContent className="flex">
              <FlexBox>
                <TextWrapper show={this.state.show}>
                  {this.props.tiff ? (
                    <>
                      <NoticeText>{this.props.typeFirst}</NoticeText>
                      <p></p>
                      <p>
                        <NoticeText>{this.props.typeSecond}</NoticeText>
                      </p>
                    </>
                  ) : (
                    <NoticeText>{this.props.type}</NoticeText>
                  )}
                  <NoticeHeading>{this.props.heading}</NoticeHeading>
                  <NoticeBlock show={this.state.show}>
                    {this.props.body}
                  </NoticeBlock>
                  {this.props.footer && (
                    <NoticeFooter>{this.props.footer}</NoticeFooter>
                  )}
                </TextWrapper>
                {this.state.show && this.props.tiff ? null : (
                  <>
                    {!this.props.hideButton && (
                      <ButtonWrapper>
                        {this.state.show ? (
                          <SecondaryButtonWrapper
                            onClick={this.toggleNoticeBlock}
                            id={this.props && this.props.id }
                          >
                            <span>Show Less</span>
                            <img src={upArrow} alt="rise" />
                          </SecondaryButtonWrapper>
                        ) : (
                          <SecondaryButtonWrapper
                            onClick={this.toggleNoticeBlock}
                            id={this.props && this.props.id }
                          >
                            <span>Show More</span>
                            <img src={downArrow} alt="fall" />
                          </SecondaryButtonWrapper>
                        )}
                      </ButtonWrapper>
                    )}
                  </>
                )}
              </FlexBox>
            </NoticeContent>
          }
        />
      </div>
    );
  }
}

Alert.propTypes = {
  body: PropTypes.string,
  footer: PropTypes.string,
  heading: PropTypes.string,
  hideButton: PropTypes.bool,
  id: PropTypes.string,
  tiff: PropTypes.bool,
  type: PropTypes.string,
  typeFirst: PropTypes.string,
  typeSecond: PropTypes.string
};

export default Alert;
